(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sectionId = '{{ section.id }}';
  var banner = document.getElementById('feature-banner-' + sectionId);
  var inner  = document.getElementById('bannerInner-' + sectionId);
  var dots   = document.querySelectorAll('#bannerDots-' + sectionId + ' span');

  /* ── Scroll dots ── */
  if (inner && dots.length) {
    inner.addEventListener('scroll', function () {
      var items     = inner.querySelectorAll('.feature-banner__item');
      var itemWidth = items[0] ? items[0].offsetWidth : 1;
      var idx       = Math.round(inner.scrollLeft / itemWidth);
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    });
  }

  /*
    ── Auto-move to DOM top (fallback safety net) ──
    Only runs on the live storefront, NOT inside the customizer
    preview (window.Shopify.designMode === true).
    Moves the banner to be the very first element inside <main>
    so even if a merchant drags it to position #3 in the section
    list, it still physically renders at the top of the page.
  */
  if (banner && !(window.Shopify && window.Shopify.designMode)) {
    var target = document.querySelector('main') ||
                 document.querySelector('[role="main"]') ||
                 document.body;

    if (target && target.firstChild !== banner) {
      target.insertBefore(banner, target.firstChild);
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
